import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';

import styles from './sync-control-loading.scss';

interface SyncControlLoadingProps {
  error?: boolean;
}

export const SyncControlLoading = ({ error }: SyncControlLoadingProps) => (
  <div className={styles.loadingContainer}>
    {error ? (
      <div className={styles.error}>
        <FormattedMessage
          id="predict.connection_error_try_again"
          defaultMessage="Connection error. Please try again."
        />
      </div>
    ) : (
      <LoaderSpinner showSpinnerLabel={false} size="small" />
    )}
  </div>
);
